import { useQuery } from '@apollo/client';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { BookmarkParentType } from '~/apollo/generated/v4/graphql';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { SOItemListV4 } from '~/components/supporting-object/so-item-list-v4';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const STUDY_VARIOGRAMS_PAGE = graphql(`
  query StudyVariogramsPage($id: ID!) {
    studyGet(id: $id) {
      id
      variograms {
        ...variogramParts
        pictures {
          ...soPictureParts
        }
        files {
          ...fileParts
        }
      }
    }
  }
`);

export default function StudyVariogramsPage() {
  return (
    <ApolloProviderV4>
      <StudyVariogramsPageInner />
    </ApolloProviderV4>
  );
}

function StudyVariogramsPageInner() {
  const studyId = useRouteParam('studyId', parseInt);

  const { data, loading } = useQuery(STUDY_VARIOGRAMS_PAGE, {
    variables: { id: studyId },
  });

  const refetchQueries = createRefetchQueries([
    { query: STUDY_VARIOGRAMS_PAGE, variables: { id: studyId } },
  ]);

  const variograms = data?.studyGet?.variograms ?? [];

  if (loading) return <SpinnerPlaceholder />;

  return (
    <SOItemListV4
      items={variograms}
      soParentType="study"
      soParentId={studyId}
      bookmarkParentType={BookmarkParentType.Variogram}
      refetchQueries={refetchQueries}
    />
  );
}
